module.exports = __webpack_public_path__ + "img/chat-file-upload.99b095d2.svg";